import { CommonModule } from "@angular/common";
import {
    ComponentFactory,
    ComponentFactoryResolver,
    NgModule,
} from "@angular/core";

import {
    SvgIconComponent,
    svgLivechat,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";
import { BasketStateModule } from "@hermes/states/basket";
import { ErrorsStateModule } from "@hermes/states/errors-state";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { LivechatButtonComponent } from "./components/livechat-button/livechat-button.component";
import { LiveChatService } from "./services/livechat.service";
@NgModule({
    declarations: [LivechatButtonComponent],
    exports: [LivechatButtonComponent],
    imports: [
        BasketStateModule,
        CommonModule,
        SvgIconComponent,
        ErrorsStateModule,
        SrOnlyNoSnippetDirective,
    ],
    providers: [LiveChatService],
})
export class LivechatModule {
    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        svgRegistryService: SvgRegistryService,
    ) {
        svgRegistryService.registerSvgs([svgLivechat]);
    }

    public resolveComponent(): ComponentFactory<LivechatButtonComponent> {
        return this.componentFactoryResolver.resolveComponentFactory(
            LivechatButtonComponent,
        );
    }
}
